import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/gestion_proyecto/colaborador';
import Colaborador from './Colaborador';

const ms2p = (state) => {
  return {
    ...state.proyecto_colaborador,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Colaborador);
